module.exports = __webpack_public_path__ + "images/d359aea53869f72166f245b21447a3c2-illu_hub_keypad_box.png";